import { ChessTermType, } from "@chesshotel/types";
import { Chess, KING, swapColor, PAWN, KNIGHT, } from "@chesshotel/chess";
import { pieceValues, exchangeEvaluation, uci2move, move2uci, } from "../util.js";
function isSkewerDefendable(fen, front, back, attacker) {
    const chess = new Chess(fen);
    const opponentColor = chess.turn();
    const color = swapColor(opponentColor);
    const frontPieceMoves = chess.moves({ square: front, verbose: true });
    const backPieceMoves = chess.moves({ square: back, verbose: true });
    let maxGain = null;
    for (const frontMove of frontPieceMoves) {
        const temp = new Chess(fen);
        const moveGain = exchangeEvaluation(fen, frontMove.to, {
            from: frontMove.from,
        }).gain;
        if (moveGain < 0) {
            continue;
        }
        temp.move(frontMove);
        const attackerCanStillCapture = temp
            .moves({ square: attacker, verbose: true })
            .some((m) => m.to === back || m.to === frontMove.to);
        if (attackerCanStillCapture) {
            const gainBack = exchangeEvaluation(temp.fen(), back).gain;
            const gainFront = exchangeEvaluation(temp.fen(), front).gain;
            const gain = Math.max(gainBack, gainFront);
            if (maxGain == null || gain < maxGain) {
                maxGain = gain;
            }
            if (gain <= 0) {
                return { isDefendable: true };
            }
        }
        else {
            return { isDefendable: true };
        }
    }
    for (const backMove of backPieceMoves) {
        const temp = new Chess(fen);
        const moveGain = exchangeEvaluation(fen, backMove.to, {
            from: backMove.from,
        }).gain;
        if (moveGain < 0) {
            continue;
        }
        temp.move(backMove);
        const attackerCanStillCapture = temp
            .moves({ square: attacker, verbose: true })
            .some((m) => m.to === front || m.to == backMove.to);
        if (attackerCanStillCapture) {
            const gainFront = exchangeEvaluation(temp.fen(), front).gain;
            const gainBack = exchangeEvaluation(temp.fen(), backMove.to).gain;
            const gain = Math.max(gainFront, gainBack);
            if (maxGain == null || gain < maxGain) {
                maxGain = gain;
            }
            if (gain <= 0) {
                return { isDefendable: true };
            }
        }
        else {
            return { isDefendable: true };
        }
    }
    return { maxGain, isDefendable: false };
}
export function detectSkewer(fen, moveStr) {
    const chess = new Chess(fen);
    const color = chess.turn();
    const move = chess.move(uci2move(moveStr));
    const opponentColor = chess.turn();
    const newFen = chess.fen();
    if (move.piece == PAWN || move.piece == KING || move.piece == KNIGHT) {
        return null;
    }
    const exEval = exchangeEvaluation(chess.fen(), move.to);
    if (exEval.gain > 0) {
        return null;
    }
    const oponentPieces = chess.pieces(opponentColor);
    let skewer = null;
    for (const piece of oponentPieces) {
        const chess = new Chess(newFen);
        const attackRay = chess.attackRay(piece.square, move.to);
        if (attackRay) {
            const [firstPiece, nextPiece] = attackRay;
            const mainPiece = { type: move.piece, square: move.to, color: color };
            const mainPieceValue = pieceValues[mainPiece.type];
            const nextPieceValue = pieceValues[nextPiece.type];
            const firstPieceValue = pieceValues[firstPiece.type];
            const isSkewer = firstPiece.type != PAWN &&
                firstPieceValue > nextPieceValue &&
                firstPieceValue > mainPieceValue;
            if (!isSkewer) {
                continue;
            }
            const { isDefendable, maxGain } = isSkewerDefendable(newFen, firstPiece.square, nextPiece.square, mainPiece.square);
            if (isDefendable) {
                return null;
            }
            const arrows = [{ from: mainPiece.square, to: nextPiece.square }];
            const captureMove = { from: firstPiece.square, to: mainPiece.square };
            skewer = {
                translationKeys: {
                    piece: firstPiece.type,
                    piece2: nextPiece.type,
                    color,
                },
                term: ChessTermType.SKEWER,
                move: move,
                mainPiece,
                attackedPiece: firstPiece,
                involvedPiece: nextPiece,
                maxGain,
                pieceWin: nextPiece.type,
                arrows,
                followMoves: [move2uci(captureMove)],
            };
            break;
        }
    }
    return skewer;
}
//# sourceMappingURL=skewer.js.map